module.exports = __webpack_public_path__ + "static/img/gaozhongdili6.8cdad5c8.jpg";